import { companySizeService } from '../../helpers/services/companySize.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const SIZE_MODULE = 'companySize'; 

// define action 
export const GET_ALL_SIZES = 'getAllSizes';
export const GET_SIZE = 'getSize';
export const UPDATE_SIZE = 'updateSize';
export const CREATE_SIZE = 'createSize';
export const UPDATE_SIZE_STATUS = 'updateSizeStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_SIZES_REQUEST = "getAllSizes";
const GET_SIZE_REQUEST = "getSize";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_SIZES]({ commit }, { filter }) {
        companySizeService
            .getAllSizes(filter)
            .then(
                (result) => {
                    commit(GET_ALL_SIZES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_SIZE]({ commit }, { id }) {
        companySizeService
            .getSize(id)
            .then(
                (result) => {
                    commit(GET_SIZE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_SIZE]({ commit }, { data }) {
        commit(REQUEST)
        companySizeService
            .updateSize(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('label.xSize', [i18n.t('module.company')])]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_SIZE]({ commit }, { data }) {
        commit(REQUEST)
        companySizeService
            .createSize(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('label.xSize', [i18n.t('module.company')])]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_SIZE_STATUS]({ dispatch }, { filter, data }) {
        companySizeService
            .updateSizeStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_SIZES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Company-size-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_SIZES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_SIZE_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }

    }
}


